import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Kami level power? Take my `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`root`}</code>{` and show me the `}<a parentName="p" {...{
        "href": "#install"
      }}>{`code`}</a>{`...`}</p>
    <h1>{`Nix is More Powerful Pkg Manger!`}</h1>
    <p>{`In pkg managing universe, if Conda is `}<a parentName="p" {...{
        "href": "../2018-11-18-conda-everything"
      }}>{`miniverse`}</a>{`, Nix would be, let's take one step further, perhaps the real universe, or the last step before entering hybrid simulation world like docker etc. In package management and dev env setup, Nix is already system-level (God/Kami) isolation for *nix system! Though it doesn't isolate process and memory like docker does, which is still in my boundary of package manager. Setting up reproducible, reliable and efficient dev environment is what it can do best. Conda and others cannot do that because many pkg manager's dependencies are runtime and sensitive to envs and paths.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/bd222befdb546cb5d4ade6416351f61d/21b4d/god-goku.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "92.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFEklEQVQ4y4WUa0zTVxjG33//vdEiVy+IUblVRBF1oCBCRATHEAW5iJMUdSA3C4pxggIWiwoUBKEgtAUKFKSU6+QmbsWhIJvIwMwtRtR52add/bBlIu15V+aSZYu6J3lzkpOcX85zzvu8AP8Rr/8m8D4bB1ahjGaJC4CVkbuVyj4Xan2hCmxL5TQigqXPFjANi4J3inIUALvmMtCqNqArVNTcHqPnOjDrNFVWmt7fYmIPLAxPEkHE8DgDjND/FVs7ACx5E9CnCxhUUjpA4lGBSewhX6isnV59bRQ/6NFp9UaQn7GCjJVlrOPVdW8Hslp6gVmqpKDgErgOT8DCitr+eVmSpyBXGzaO3sWcL7/+EcSFCb7F5ZHLpGWwTFrOOCV/B5A+kkHBoaPASc20oFKOpm+43IXzzhYhtA8QR91t3NM5MMMtV/6y+cqnIzD5GIy2qZjTkjfDeCFhwG5oZ8zZ5sibAunSaoz+ZHDWWnnZwG7QErP+G2SBSmvglSnQvW/4h6ai4pWzz1+AfGzyr7ce1sr+gR22oQE2bgNWsYw22gNu7vkU+86r6NDYNuvS2IZcdQehKmrQo0dHnDoG9VYXFWguLsgOSkmGWImYeUcU/tohg/Ea+MzLGtAE4L3UJNotPBhgf3zypu5BtKqo0QcMfUEcVC0E8gox5u5DdG/u0nv3DqGvSHRLtsTE9kn2YdBkiKi5VvJxc3oNvGnHhq3+PoxAD1eIcrOPEMQnPLQvqSTLi2XEQ9NNdrV2o1tjG4m+cYeEDAzjRyOThj3CSLx1MvLV6NStMEQ9aOoV9Jgyk+6VS5iQtYRFnZwPkGJn4VC8GP6IkYjRVak2mGZkoa/mClJpxzG0s5/41LWQvcb14NURFCZ9ODMdL8DHt7t1NVUq47VsYKIpDzpkOQBnVvDp03YcOOG+sFjjTOPGiB0zjsomdFG1kqw6GakvEqGXuoVsVShwfUkZ8SmrJKXb7Q3TERy8krHzEbie9AHw5XRI0xJby7JF0BJkT9fvcIb8HavKxzbxscTXVu+dd5Y4S4tJVXs14jfd5FhlPh5RVZHMzETSLHTCiT3m+gdx5rh7iz9yAmoxICT5pz5JDE60GtvsYrqQnZ/7MVzIOBA7GSXALk/uS7H7YkOitwDT0vYRRXUBGW3OJ2O6NpyoPUPuRfFePY2bj32hli9ZNmuvMxzD7q13WftILQrEr9pKJiAu0BXmfomxLn4oLSgKh1wAr3lxsMuDSRqj1+GDTil5MiDDn6d6DXdL4vXjkVzUBZt/X+NAh2j9doOXMbVz5xWiEL8z+7cvg6pTh9zjd3qXLfJMRWs/6YtLjoxLLWs5D78VWuB4soA80Bbg/UGlYeTsQRwNt8LG7fweexu+dZ2HCaA0gTL9u59rU3eCNDkMoK/o8O/arGiM2+ahp1wOhEvWOIPQmrVCvcHk188DODgUbKFXhAjwvDP3WbMXU4hiHmxbYQrtm3nGRLiB2QLHuVkF8uT3GQ05BykYbZP1THWUYMe5OFVhhcbod4whP2FronBiTrevYeNklPnM8C4+lnvy0kf8WYDHzOhcz3lUZZAZdCYuglw7+t85xu8aoCg/d/k5dS8f8QT0eVnS/Q401K9iK8YD+Pg8Yf7slNAauyMsg3r3WkFnqAXtvZQD5e5cWMl7w2DA4X1QcSEP1APXQJqXA8r1ALuXsmD1YhZX589vub/fCq/utSqam7cWZjQogs0h0Ziut+lPGKI+9KGfzdEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Want to be God-Level Goku?",
            "title": "Want to be God-Level Goku?",
            "src": "/static/bd222befdb546cb5d4ade6416351f61d/0a47e/god-goku.png",
            "srcSet": ["/static/bd222befdb546cb5d4ade6416351f61d/8a4e8/god-goku.png 150w", "/static/bd222befdb546cb5d4ade6416351f61d/5a46d/god-goku.png 300w", "/static/bd222befdb546cb5d4ade6416351f61d/0a47e/god-goku.png 600w", "/static/bd222befdb546cb5d4ade6416351f61d/1cfc2/god-goku.png 900w", "/static/bd222befdb546cb5d4ade6416351f61d/c1b63/god-goku.png 1200w", "/static/bd222befdb546cb5d4ade6416351f61d/21b4d/god-goku.png 1280w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Want to be God-Level Goku?`}</figcaption>{`
  `}</figure>
    <p>{`Note the price to pay: root permission, but you can do `}<a parentName="p" {...{
        "href": "https://github.com/nix-community/nix-user-chroot#user-content-installation"
      }}>{`without permission`}</a>{` if namespace supported or rebuild everything from scratch if you set store in different location than `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/nix/store`}</code>{`. For linux, you have to use NixOS to enable the full power manipulating hardware and services.`}</p>
    <h1>{`Features Summary`}</h1>
    <h2>{`Immutable Dependencies`}</h2>
    <p>{`Means it freezes the deps during build, and it hardcodes the tool-chain (e.g. GCC) to ignore any global system wide variable (/usr/include) and version of lib. Therefore, it can handle many different version independently for even the same app and make your life easier. `}</p>
    <h2>{`Versions`}</h2>
    <p>{`When you install, Nix uses Sqlite to persist your version and prepares for rolling back! It also creates symlink as in:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token environment constant"
          }}>{`$HOME`}</span>{`/.nix-profile/`}</code></pre></div>
    <p>{`Because of hardcoding, rolling back or version control is blasting fast just similar to how git hand files.`}</p>
    <h2>{`Easy Going as Other Managers`}</h2>
    <p>{`If you are familar with other manager tool, interacting with nix user environment is similar, e.g.:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`Install -> nix-env -i pkgname
Uninstall -> nix-env -e pkgname
List -> nix-env -q`}</code></pre></div>
    <h2>{`Easy Share`}</h2>
    <p>{`You can create your own environment `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.nix`}</code>{` and share it easily to your colleagues. You can also build it to docker or virtual hard drive image!`}</p>
    <h2>{`Nix Expression & Language`}</h2>
    <p>{`It adapts functional programming so everything is an expression/lambda/function and variables are immutable. You can use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`nix repl`}</code>{` to play with language.`}</p>
    <p>{`You can compile expression to create derivatives which describe how to build a package. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.nix`}</code>{` is like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.c`}</code>{` in C; while `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.drv`}</code>{` is like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.o`}</code>{`. Many people are scared by it?`}</p>
    <h2>{`Build Your Own Pkgs`}</h2>
    <p>{`It's all about writing a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.nix`}</code>{` `}<a parentName="p" {...{
        "href": "https://nixos.org/guides/nix-pills/generic-builders.html#idm140737320276672"
      }}>{`expression`}</a>{`. Find a nice `}<a parentName="p" {...{
        "href": "https://github.com/NixOS/nixpkgs/blob/master/pkgs/tools/misc/fzf/default.nix"
      }}>{`example`}</a>{` in `}<a parentName="p" {...{
        "href": "https://github.com/NixOS/nixpkgs/tree/master/pkgs"
      }}>{`pkgs`}</a>{` and copy/paste!`}</p>
    <p>{`If you want to know the configs available in home-manager, just look into `}<a parentName="p" {...{
        "href": "https://github.com/nix-community/home-manager/blob/master/modules/programs/neovim.nix"
      }}>{`code`}</a>{`.`}</p>
    <div id="install"></div>
    <h1>{`Install Nix`}</h1>
    <p>{`It's very easy to follow `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/master/installNix.sh"
      }}>{`here`}</a>{` if you have root. Otherwise, you either need namespace and do:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`wget`}</span>{` https://github.com/nix-community/nix-user-chroot/releases/download/1.0.3/nix-user-chroot-bin-1.0.3-x86_64-unknown-linux-musl `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-O`}</span>{` nix-user-chroot
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`chmod`}</span>{` +x nix-user-chroot
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`mkdir`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-m`}</span>{` 0755 ~/.nix
./nix-user-chroot ~/.nix `}<span parentName="code" {...{
            "className": "token function"
          }}>{`bash`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-c`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"curl -L https://nixos.org/nix/install | bash"`}</span></code></pre></div>
    <p>{`After you can run `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`nix-user-chroot ~/.nix bash`}</code>{` to start bash where `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/nix`}</code>{` is mounted with namespace. You might also want to put `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`nix-user-chroot`}</code>{` to your `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`$PATH`}</code>{`. `}</p>
    <p>{`You can play with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`nix-env -i`}</code>{` to install any packages. `}</p>
    <h1>{`Install Home-Manager`}</h1>
    <p>{`You can define your nix environment and quickly switch it.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# install home-manager`}</span>{`
nix-channel `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--add`}</span>{` https://github.com/nix-community/home-manager/archive/master.tar.gz home-manager
nix-channel `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--update`}</span>{`
nix-shell `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'<home-manager>'`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-A`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span></code></pre></div>
    <p>{`It's must-have if you like Nix to manage your dotfiles and home folder etc.`}</p>
    <h1>{`Setup Pkgs At Home`}</h1>
    <p>{`Here's I did some env var trick to switch different profiles, like "base", etc. to point to a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`cli.nix`}</code>{` file that contains the actual code of pkgs:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` config`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` profiles `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Base includes shell and utility related install`}</span>{`
  base `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    `}<span parentName="code" {...{
            "className": "token url"
          }}>{`./profiles/cli.nix`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
envProfile `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`builtins`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`getEnv`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"MY_NIX_PROFILE"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# I'm sure here can do better, now tolerate nix baby language 😂`}</span>{`
profile `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`envProfile`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`"`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`==`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`""`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`then`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"base"`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`else`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`envProfile`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`"`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  nixpkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`config`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`allowUnfree `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Let Home Manager install and manage itself.`}</span>{`
  programs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`home`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span>{`manager`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`enable `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  imports `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`builtins`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`hasAttr`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`profile`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`"`}</span>{` profiles`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`then`}</span>{` profiles`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`profile`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`"`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`else`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`profile`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`"`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`#`}</span>{`
  home`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`username `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"Zeng Dai"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  home`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`homeDirectory `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`builtins`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`getEnv`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"HOME"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Starting ver`}</span>{`
  home`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`stateVersion `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"20.09"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}</code></pre></div>
    <p>{`Then in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`cli.nix`}</code>{` for "base" profile, it mainly install the CLI tools (my precious pick):`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` config`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` lib`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
  comma `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`fetchFromGitHub `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      owner `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"Shopify"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      repo `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"comma"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      rev `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"4a62ec17e20ce0e738a8e5126b4298a73903b468"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      sha256 `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"0n5a3rnv9qnnsrl76kpi6dmaxmwj1mpdd2g0b4n1wfimqfaz6gi1"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  home`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`packages `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    fzf
    vim
    direnv `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# how to setup nix-shell? https://nixos.org/guides/declarative-and-reproducible-developer-environments.html#declarative-reproducible-envs`}</span>{`
    httpie
    tmux
    ag
    fasd
    ripgrep
    tree
    broot
    ranger
    trash`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span>{`cli
    rsync
    fd
    exa
    comma
    bat
    htop
    navi
    tldr
    neofetch
    tokei
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <h1>{`Customization Home`}</h1>
    <p>{`How about the dotfiles? The Nix language provides tons of flexibility to do whatever you need to do. Mostly you can check the options of customization, for `}<a parentName="p" {...{
        "href": "https://github.com/nix-community/home-manager/blob/master/modules/programs/neovim.nix"
      }}>{`example`}</a>{`.`}</p>
    <p>{`Basically, it allows you to put all dotfiles into the nix scripts.`}</p>
    <h1>{`Desktop App`}</h1>
    <p>{`For Linux, you simply install it in Nix. To make it appear in your e.g. Gnome launchpad, you need to create `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.profile`}</code>{` like:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# Makesure gnome know these path`}</span>{`
`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`NIX_HOME_PATH`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token environment constant"
          }}>{`$HOME`}</span>{`/.nix-profile
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-e`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`$NIX_HOME_PATH`}</span>{`/etc/profile.d/nix.sh `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`then`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`.`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`$NIX_HOME_PATH`}</span>{`/etc/profile.d/nix.sh`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`fi`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# added by Nix installer`}</span>{`

`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}><span parentName="span" {...{
              "className": "token environment constant"
            }}>{`XDG_DATA_DIRS`}</span></span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token environment constant"
          }}>{`$HOME`}</span>{`/.nix-profile/share:`}<span parentName="code" {...{
            "className": "token environment constant"
          }}>{`$HOME`}</span>{`/.share:`}<span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token variable"
            }}>{`\${`}<span parentName="span" {...{
                "className": "token environment constant"
              }}>{`XDG_DATA_DIRS`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:-`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`usr`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`local`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`share`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`usr`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`share`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`}`}</span>{`"`}</span></code></pre></div>
    <p>{`Logout and in to restart the desktop.`}</p>
    <p>{`For some application, it requires GL e.g. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`alacritty`}</code>{`. You need to install `}<a parentName="p" {...{
        "href": "https://github.com/guibou/nixGL"
      }}>{`nixGL`}</a>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
  nixGL `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`fetchFromGitHub `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      owner `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"guibou"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      repo `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"nixGL"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      rev `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"fad15ba09de65fc58052df84b9f68fbc088e5e7c"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      sha256 `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"1wc5gfj5ymgm4gxx5pz4lkqp5vxqdk2njlbnrc1kmailgzj6f75h"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  home`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`packages `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`with`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`
    nixGL`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`nixGLDefault
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}</code></pre></div>
    <p>{`Then run your GL application as `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`nixGL alacritty`}</code>{`.`}</p>
    <p><strong parentName="p">{`HOWEVER`}</strong>{`, desktop support for non NixOS is limited. Basically you need many knowledge regarding your X window environment and build many things from scratch, while only NixOS has native support. If you are interested how I achieved that under Centos, please check out `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/tree/master/nix/nixpkgs"
      }}>{`my nix files`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/master/linux/.profile"
      }}>{`.profile`}</a>{`. Each X window desktop have its own implementation that not necessarily follows statndard. You can enable `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`home-manager`}</code>{`'s xserver support but without NixOS, you have to know and hookup everything on your own. On Mac most app e.g. firefox won't be available, you have to write some `}<a parentName="p" {...{
        "href": "https://github.com/cmacrae/config/blob/b33ccb041861b56c97e1744b0fd8c606e343164c/overlays/firefox/default.nix"
      }}>{`wrapper`}</a>{` to download/unpack dmg to cheat. At least you don't need to stick to brew cask.`}</p>
    <h1>{`Systemd Service`}</h1>
    <p>{`If you want to start daemon service in Linux, for example, a cloud folder, you can use home-manager to setup these service like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}>{`  systemd`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`user `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    services`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`dropbox_rclone `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
        mountdir`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`config`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`home`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`homeDirectory`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`/cloud/dropbox"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      Unit `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        Description `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"dropbox rclone mount"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      Install`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`WantedBy `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"multi-user.target"`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      Service `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
          ExecStartPre `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`pkgs`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`coreutils`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`/bin/mkdir -p `}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`mountdir`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
          ExecStart `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`''
              `}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`pkgs`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`rclone`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`/bin/rclone mount dropbox: `}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`mountdir`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`
          ''`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
          ExecStop `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`pkgs`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`fuse`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`/bin/fusermount -uz `}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token antiquotation important"
              }}>{`$`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`mountdir`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
          Type `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"notify"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
          Restart `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"always"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
          RestartSec `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"10s"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <h1>{`Development`}</h1>
    <p>{`This is the area that Nix really shines. With Nix you basically could dump all other package managers. For example, you could nail down the particular version of main source `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`nixpkgs`}</code>{` like:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` pkgs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`?`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`fetchTarball`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"https://github.com/NixOS/nixpkgs/archive/3590f02e7d5760e52072c1a729ee2250b5560746.tar.gz"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`to pin a specific python package:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "nix"
    }}><pre parentName="div" {...{
        "className": "language-nix"
      }}><code parentName="pre" {...{
          "className": "language-nix"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` pkgs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`?`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`import`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`nixpkgs`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{`
  myranger `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`python3`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`buildPythonPackage rec `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    pname `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"ranger-fm"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
    version `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"1.9.0"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

    src `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`python3`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`fetchPypi `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`inherit`}</span>{` pname version`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`#format = "wheel"; # tar.gz is default`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# python = "cp38";`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# abi = "cp38";`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# platform = "manylinux1_x86_64";`}</span>{`
      sha256 `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"1ay8lhgkqzmvavinbmzdgh8pgkddpx72pygi4d9ac01jbbggibkg"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`#format = "wheel"; # tar.gz is default`}</span>{`

    meta `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      homepage `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"..."`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      description `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"..."`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  pythonEnv `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`python3`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`withPackages `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`ps`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    myranger
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` pkgs`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`mkShell `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  buildInputs `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    pythonEnv
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}</code></pre></div>
    <p>{`For general packages, you can always take a look at the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`default.nix`}</code>{` for the package you want to pin.`}</p>
    <p>{`Plus the power of `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`direnv`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.envrc`}</code>{` you can do auto shell env change when enter the folder!`}</p>
    <h1>{`NixOS`}</h1>
    <p>{`Under NixOS, this idea is pushed further. Everything in OS is configurable in Nix language. I like the idea of using language to define your machine in a uniform way, but unfortunately so far only NixOS is supported. It means not transferrable to other OS. Probably I'll try it out in the future post.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      